<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";

    const dispatcher = createEventDispatcher();

    onMount(() => {
    });


</script>

<span class="edit-button-view" on:click>
    <FontAwesomeView icon="edit"/>


</span>
<style lang="scss">
    .edit-button-view {
        opacity: 0.5;
        cursor: pointer;

        &:hover {
            opacity: 1;
        }

    }
</style>